import React, { useEffect, useState, Fragment } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
import { TOTAL_CUPOS } from '../data/content';
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function UrgencyBar() {
  // countdown starting from a fixed target for this session (approx 3h)
  const [remaining, setRemaining] = useState(3 * 3600 + 24 * 60 + 51);
  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(r => r > 0 ? r - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(remaining / 3600);
  const m = Math.floor(remaining % 3600 / 60);
  const s = remaining % 60;
  const cuposRestantes = TOTAL_CUPOS;
  const cuposTotal = 1500;
  const pct = Math.round(cuposRestantes / cuposTotal * 100);
  return <div className="rounded-xl border border-[#F5C518]/40 bg-black/60 p-4" data-id="element-158">
      <div className="flex items-center justify-center gap-2 text-[#F5C518]" data-id="element-159">
        <ClockIcon className="h-4 w-4" data-id="element-160" />
        <span className="font-oswald text-xs font-700 uppercase tracking-wide" data-id="element-161">
          La oferta termina en
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-162">
        {[{
        v: h,
        l: 'Horas'
      }, {
        v: m,
        l: 'Min'
      }, {
        v: s,
        l: 'Seg'
      }].map((t, i) => <Fragment key={t.l} data-id="element-163">
            <div className="flex flex-col items-center" data-id="element-164">
              <span className="min-w-[52px] rounded-lg bg-[#F5C518] px-2 py-1.5 text-center font-anton text-2xl text-black tabular-nums" data-id="element-165">
                {pad(t.v)}
              </span>
              <span className="mt-1 text-[10px] uppercase tracking-wide text-neutral-400" data-id="element-166">
                {t.l}
              </span>
            </div>
            {i < 2 && <span className="pb-4 font-anton text-2xl text-[#F5C518]" data-id="element-167">:</span>}
          </Fragment>)}
      </div>

      <div className="mt-4" data-id="element-168">
        <div className="mb-1.5 flex items-center justify-between text-[12px]" data-id="element-169">
          <span className="flex items-center gap-1.5 text-neutral-300" data-id="element-170">
            <UsersIcon className="h-3.5 w-3.5 text-[#F5C518]" data-id="element-171" /> Cupos restantes
          </span>
          <span className="font-700 text-[#F5C518]" data-id="element-172">
            {cuposRestantes} cupos
          </span>
        </div>
        <div className="h-2.5 w-full overflow-hidden rounded-full bg-white/10" data-id="element-173">
          <div className="h-full rounded-full bg-[#F5C518]" style={{
          width: `${pct}%`
        }} data-id="element-174" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-neutral-400" data-id="element-175">
          Últimos cupos a este precio — se agotan rápido
        </p>
      </div>
    </div>;
}